import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-logo-proj',
    templateUrl: './logo-proj.component.html',
    styleUrls: ['./logo-proj.component.less']
})
export class LogoProjComponent {
    @Input() size = '24px';
}
